import { render, staticRenderFns } from "./is_4_com.vue?vue&type=template&id=228535f7&scoped=true&"
import script from "./is_4_com.vue?vue&type=script&lang=js&"
export * from "./is_4_com.vue?vue&type=script&lang=js&"
import style0 from "./is_4_com.vue?vue&type=style&index=0&id=228535f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228535f7",
  null
  
)

export default component.exports